"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialIconButton = void 0;
const router_1 = require("client/components/router");
const IconButton_1 = require("material-ui/IconButton");
const react_1 = require("react");
const React = require("react");
require("./icon-button.less");
class MaterialIconButton extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onClick = (e) => {
            const { onClick, to } = this.props;
            if (to) {
                router_1.RouteManager.transitionTo(to);
            }
            onClick && onClick(e);
        };
    }
    render() {
        const { children, disabled, primary, secondary } = this.props;
        const primaryColor = primary ? "primary" : null;
        const secondaryColor = secondary ? "secondary" : null;
        const color = primaryColor || secondaryColor || "default";
        const isDisabled = disabled ? "disabled" : "";
        return (React.createElement("span", { className: `material-icon-button ${isDisabled}` },
            React.createElement(IconButton_1.default, { color: color, disabled: disabled, onClick: this.onClick }, children)));
    }
}
exports.MaterialIconButton = MaterialIconButton;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/icon-button/icon-button.tsx
// module id = 3155
// module chunks = 0